module.exports = __webpack_public_path__ + "static/media/curriculum_s3.80507f57.png";